import { render, staticRenderFns } from "./ModalSelecionarEmpresaBeneficiario.vue?vue&type=template&id=6f0fd524"
import script from "./ModalSelecionarEmpresaBeneficiario.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarEmpresaBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarEmpresaBeneficiario.vue?vue&type=style&index=0&id=6f0fd524&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports